import React from 'react';
import './css/app.css';
import Navigation from './layouts/Navigation';
import { Route, Switch } from 'react-router-dom';
import Login from './components/Login';
import Footer from './layouts/Footer';
import Vending from './components/Vending';
import ProtectedRoute from './components/ProtectedRoute';
import Sales from './components/Sales';
import Favorites from './components/Favorites';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { TokenReprint } from './components/TokenReprint';

function App() {
   return (
      <React.Fragment>
         <ToastContainer />
         <div id='app-container'>
            <Navigation />
            <main>
               <Switch>
                  <Route exact path={'/'} component={Login} />
                  <Route exact path={'/login'} component={Login} />
                  <Route path={'/home'} component={Login} />
                  <Route exact path={'/token/:transactionId'} component={TokenReprint} />
                  <Route path={'/token'} component={TokenReprint} />
                  <ProtectedRoute path={'/vend'} component={Vending} />
                  <ProtectedRoute path={'/sales'} component={Sales} />
                  <ProtectedRoute path={'/favorites'} component={Favorites} />
               </Switch>
            </main>
            <Footer />
         </div>
      </React.Fragment>
   );
}

export default App;
